<template>
  <div class="main_">
    <top-header :type="6" :hasBorder="true" :placeholder="'银行网签操作员签约排行'" fontSize="0.32rem" />
    <div class="list_con">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner m_flex_box flex_vc flex_jz" v-for="(item, index) in list" :key="index" @click="toDetail('/agentDetail', {id: item.id,compType:1})">
            <div class="left">
              <img :src="imgPath + 'sClf/' + item.brokerImg + '.jpg'" alt="">
              <span :class="index < 3 ? 'before' : ''">top{{index + 1}}</span>
            </div>
            <div class="right">
              <h3 class="m_flex_box flex_jz flex_vc">
                <span>{{item.brokerName}}</span>
                <i>{{item.signCount}}套</i>
              </h3>
              <p class="address line_comp1">所属机构：{{item.compName}}</p>
              <p class="address line_comp1">所属门店：{{item.storeName}}</p>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  name: 'BankOpreatorList',
  data() {
    return {
      isLoading: false,
      list: [],
      listPage:1,
      loading: false,
      finished: false,
      timer: null,
    };
  },
  components: {
    topHeader
  },
  mounted() {

  },
  methods: {

    toDetail(path, query) {
      this.$router.push({
        path,
        query
      })
    },

    onRefresh() {
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'listPage', 1);
      this.onLoad(1);
    },

    onLoad(type) {
      if(!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: 'cms/broker/permit/getBrokerListNew.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            compType: 1,
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
            area: this.main.getHostArea(),
            sort:0
          }
        }).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },

  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'AgentDetail'){
      this.$store.dispatch('saveView', ['BankOpreatorList']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
.list_con{
  width: 7.04rem;
  margin: 0 auto;
  .inner{
    padding: 0.34rem 0;
    border-bottom: 1px solid #f5f5f5;
    .left{
      margin-right: 0.26rem;
      position: relative;
      img{
        width: 1.3rem;
        height: 1.3rem;
        display: block;
        border-radius: 50%;
      }
      span{
        display: block;
        position: absolute;
        background-color: #404040;
        color: #fff;
        width: 0.8rem;
        line-height: 0.38rem;
        border-radius: 0 0.08rem 0 0.08rem;
        font-size: 0.22rem;
        text-align: center;
        top: 1rem;
        left: 50%;
        margin-left: -0.4rem;
        font-weight: 800;
        &.before{
          background-color: #FF342A;
        }
      }
    }
    .right{
      width: 5.45rem;
      h3{
        font-size: 0.3rem;
        font-weight: 600;
        i{
          font-size: 0.26rem;
          font-weight: 600;
        }
      }
      .address{
        font-size: 0.24rem;
        color: #909090;
        margin: 0.1rem 0;
      }
    }
  }
}
</style>